import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=2c5ce0ac&scoped=true&"
import script from "./AllProducts.vue?vue&type=script&lang=js&"
export * from "./AllProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ce0ac",
  null
  
)

export default component.exports